import '@/bootstrap';
// import { Message } from 'element-ui';
// import { isLogged, setLogged } from '@/utils/auth';
import { getToken } from '@/utils/auth';

// Create axios instance
const service = window.axios.create({
  baseURL: process.env.VUE_APP_MIX_BASE_API,
  timeout: 120000, // Request timeout - increased to 2 minutes for complex operations
  withCredentials: true,
});

// Request intercepter
service.interceptors.request.use(
  config => {
    const token = getToken();
    if (token) {
      config.headers['Authorization'] = `Token ${token}`;
    }
    // const token = isLogged();
    // if (token) {
    //   config.headers['Authorization'] = 'Bearer ' + isLogged(); // Set JWT token
    // }
    return config;
  },
  error => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);

// response pre-processing
service.interceptors.response.use(
  response => {
    // if (response.headers.authorization) {
    //   setLogged(response.headers.authorization);
    //   response.data.token = response.headers.authorization;
    // }
    return response.data;
  },
  error => {
    let message = error.message;
    if (error.response.data && error.response.data.errors) {
      message = error.response.data.errors;
    } else if (error.response.data && error.response.data.error) {
      message = error.response.data.error;
    }
    if (message === 'CSRF token mismatch.' || error.response.data.message === 'Unauthenticated.') {
      // window.location.href = '/';
    }
    // Message({
    //   message: message,
    //   type: 'error',
    //   duration: 5 * 1000,
    // }); // tam an do van de mang evn
    return Promise.reject(error);
  }
);

export default service;
